import React from 'react'
import { Link } from 'react-router-dom'
import Wrapper from '../helpers/Wrapper'
import AnimatePage from '../components/AnimatePage'
import { ChangePageTitle } from '../helpers/ChangeTitle'


function Page404() {

    ChangePageTitle("Resource Not Found")

    return (
        <AnimatePage>
            <div className='w-full relative h-[calc(100vh-400px)] mt-10'>
                <Wrapper>
                    <div className="w-full relative py-10 space-y-5 flex flex-col items-center">
                        <h1 className="font-serif font-semibold text-4xl text-center md:text-5xl">404</h1>
                        <p className="text-gray-500 mx-auto max-w-sm font-serif text-sm text-center">
                            The page you are looking for doesn't exist or has been
                            moved, but don't worry, we'll get you back on track!
                        </p>
                        <Link
                            className=' w-fit relative bg-black block px-8 py-2.5 text-white rounded-full'
                            to='/'
                        >
                            Back to homepage
                        </Link>
                    </div>
                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default Page404